import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import OurStory from "@/pages/OurStory";
import LegacyFilms from "@/pages/LegacyFilms";
import FuneralServicesSydney from "@/pages/FuneralServicesSydney";
import FuneralServicesCanberra from "@/pages/FuneralServicesCanberra";
import Gallery from "@/pages/Gallery";
import GiftLegacy from "@/pages/GiftLegacy";
import { BlogList, BlogDetail } from "@/pages/Blog";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Navigate } from "react-router-dom";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import MemorialPage from "@/pages/MemorialPage";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/our-story" element={withLayout(<OurStory />)} />
          <Route path="/legacy-films" element={withLayout(<LegacyFilms />)} />
          <Route path="/funeral-services-sydney" element={withLayout(<FuneralServicesSydney />)} />
          <Route path="/funeral-services-canberra" element={withLayout(<FuneralServicesCanberra />)} />
          <Route path="/funeral-services" element={<Navigate to="/funeral-services-sydney" replace />} />
          <Route path="/gallery" element={withLayout(<Gallery />)} />
          <Route path="/packages" element={<Navigate to="/legacy-films#packages" replace />} />
          <Route path="/gift" element={withLayout(<GiftLegacy />)} />
          <Route path="/blog" element={withLayout(<BlogList />)} />
          <Route path="/blog/:slug" element={withLayout(<BlogDetail />)} />
          <Route path="/faqs" element={withLayout(<Faqs />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/payment/success" element={withLayout(<PaymentSuccess />)} />
          <Route path="/payment/cancel" element={withLayout(<PaymentCancel />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          {/* Memorial page (must be last — catches top-level slugs) */}
          <Route path="/:slug" element={withLayout(<MemorialPage />)} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
